@if (!translationMode) {
  <div>
    <div>
      <section class="topNavbar py-1 px-3" id="editNavbar">
        <div class="row align-items-center my-1">
          <div class="col-md-4 col-lg-4 d-flex my-2 my-md-auto flex-nowrap align-content-center align-items-center">
            <div class="component-headline text-center">
              "{{titleEdit}}"
              @if (hasDraft || draftLoaded) {
                <span class="draft-chip">{{'pass.draft' | translate}}</span>
              }
            </div>
          </div>
          <!-- desktop -->
          <div class="col-md-8 d-none d-lg-flex justify-content-end align-items-center">
            <div class="button-group">

              <button mat-button class="me-3 secondary-gray-button-2 add-widget-button" matTooltip="Sample QR" (click)="QRoptions();">
                <mat-icon>qr_code_2</mat-icon>
                {{'content.preview' | translate}}
                <span class="text-uppercase">({{languageSelected}})</span>
              </button>

              <div class="vr custom-vr d-none me-3 d-md-inline-block"></div>

              <button
                [ngClass]="{'disabled': translationDisabled}"
                mat-button
                (click)="showTranslatedView();"
                #tooltip="matTooltip"
                [matTooltip]="translationDisabled ? ('pass.translate_hint' | translate) : ''"
                matTooltip="{{'pass.translate_hint' | translate}}"
                matTooltipPosition="below"
                aria-label="Button that enables translation Mode">
                <mat-icon>translate</mat-icon>
                <span class="d-none d-md-block">{{'pass.translations' | translate}}</span>
              </button>
              <button mat-button [ngClass]="{'disabled': checkLicenseFree}" (click)="openDialogEditSettings();" data-nar="pass-settings-edit">
                <mat-icon>settings</mat-icon><span class="d-none d-md-block">{{'advancedSettings' | translate}}</span>
              </button>
              <button mat-button (click)="openDialogEditTheme();" data-nar="pass-theme-edit">
                <mat-icon>format_color_fill</mat-icon><span class="d-none d-md-block">{{'customizeTheme' | translate}}</span>
              </button>
              <!-- <button mat-button style="color:white;" (click)="openContentTypeView();"><mat-icon>tune</mat-icon><span class="d-none d-md-block">{{'contentTypeSettings' | translate}}</span></button> -->
          </div>
        </div>
        <!-- mobile -->
        <div class="col-md-8 d-lg-none">
          <div class="button-group d-flex align-items-center justify-content-end">
            <button mat-icon-button style="pointer-events: all;background: rgba(0, 0, 0, 0)!important;"
              [ngClass]="{'disabled': translationDisabled}"
              (click)="showTranslatedView();"
              matTooltip="{{'pass.translate_hint' | translate}}"
              matTooltipPosition="below"
              aria-label="Button that enables translation Mode">
              <mat-icon>translate</mat-icon>
            </button>
            <button mat-icon-button (click)="openDialogEditSettings();">
              <mat-icon>settings</mat-icon>
            </button>
            <button mat-icon-button (click)="openDialogEditTheme();">
              <mat-icon>format_color_fill</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </section>
    <div>
      <div class="custom-tab-group-wrapper">
        <div class="custom-tab-group">
          <mat-tab-group
            class="custom-tab"
            mat-align-tabs="start"
            mat-stretch-tabs="false"
            [selectedIndex]="selectedTabIndex"
            (selectedIndexChange)="onSelectedIndexChange($event)"
            >
            @for (tab of tabs; track tab) {
              <mat-tab>
                <ng-template mat-tab-label>
                  <div class="tab-label-wrapper">
                    <span class="tab-label">
                      @if (tab.isMain){
                        {{'pass.mainTabLabel' | translate}}
                      }
                      @else{
                      {{ tab.name }}
                    }
                  </span>
                  @if (!tab.isMain) {
                    <button
                      mat-icon-button
                      class="tab-menu-btn ms-2"
                      [matMenuTriggerFor]="tabActionsMenu"
                      (click)="onTabMenuButtonClick(tab, $event)"
                      >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  }
                </div>
              </ng-template>
              <div class="tab-content">
                <div
                  cdkDropList
                  [cdkDropListData]="allWidgets"
                  (cdkDropListDropped)="drop($event)"
                  >
                  @for (widget of allWidgets; track widget; let i = $index) {
                    <div
                      cdkDrag
                      (click)="clickList(widget, i, $event)"
                      >
                    </div>
                  }
                </div>
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
      <button
        matTooltip="{{'pass.newChildPage' | translate}}"
        mat-icon-button
        color="primary"
        class="ms-2 me-3"
        (click)="addChildTab()"
        >
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <mat-menu #tabActionsMenu="matMenu">
      <button mat-menu-item (click)="renameCurrentTab()">
        <mat-icon>edit</mat-icon>
        <span>{{'rename' | translate}}</span>
      </button>
      <button mat-menu-item (click)="duplicateTab(currentMenuTab?.id, $event)">
        <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
        <span>{{'duplicate' | translate}}</span>
      </button>
      <button mat-menu-item (click)="deleteTab(currentMenuTab?.id, $event)">
        <mat-icon class="material-symbols-outlined">delete</mat-icon>
        <span>{{'delete' | translate}}</span>
      </button>
    </mat-menu>
  </div>
</div>
<div class="editor-utility-bar">
  <div class="preview-tools"></div>
  <div class="editor-utility-actions">
     <mat-button-toggle-group hideSingleSelectionIndicator class="theme-toggle me-3" name="darkModeToggle" [(ngModel)]="darkMode">
      <mat-button-toggle matTooltip="Light-Mode" (click)="changeTheme(false);" [value]="false" style="border-top-left-radius:35px;border-bottom-left-radius:35px"><mat-icon>light_mode</mat-icon></mat-button-toggle>
      <mat-button-toggle matTooltip="Dark-Mode" (click)="changeTheme(true);" [value]="true"style="border-top-right-radius:35px;border-bottom-right-radius:35px"><mat-icon>dark_mode</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
    <mat-slide-toggle class="screen-switcher" [(ngModel)]="phoneFullHeightView">{{ 'fullView' | translate }}</mat-slide-toggle>
   
    <div class="vr custom-vr d-none me-3 d-md-inline-block"></div>
    <button mat-button
      [disabled]="!hasWidgetInClipboard"
      class="secondary-gray-button-2 add-widget-button me-2"
      (click)="pasteWidgetFromClipboard()">
      <mat-icon class="material-symbols-outlined">content_paste</mat-icon>
            {{ 'pass.widgets.pasteWidgetFromClipboard' | translate }}
    </button>

    <button mat-button
      class="secondary-gray-button-2 add-widget-button"
      id="btn-add"
      [matMenuTriggerFor]="widgets">
      <mat-icon>add_circle</mat-icon> {{'pass.addNewElement' | translate}}
    </button>
  </div>
</div>
<!-- mobile-message -->
<div class="d-md-none" style="background-color: #dd2f2f;color:white">
  <div class="d-flex align-items-center p-3 align-content-center">
    <span class="material-symbols-outlined m-2">error</span>
    {{'mobile_info' | translate}}
  </div>
</div>

<div class="container">
  <div class="row mt-4">
    <div class="col-xs-6 col-md-6 d-none d-md-block">
      <div class="d-flex mobile-wrapper justify-content-center align-self-center" [class.full-view]="phoneFullHeightView">
        <section class="mobile">
          <!--  *ngIf="!editTemp" -->
          <div class="mobile-frame-container"></div>
          <div class="mobile-frame">
            <!-- rendered at a real phone width (375px) and zoomed down to fit the frame -->
            <div class="preview-scale" appPreviewNoSubmit>
              <wr-reader-shell
                [document]="readerDocument"
                [preview]="true"
                [darkMode]="darkMode" />
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="col-xs-6 col-md-6">
        <mat-menu #widgets="matMenu" >
          <!-- <button mat-menu-item
            [disabled]="!hasWidgetInClipboard"
            (click)="pasteWidgetFromClipboard()">
            <mat-icon class="material-symbols-outlined">content_paste</mat-icon>
            {{ 'pass.widgets.pasteWidgetFromClipboard' | translate }}
          </button>
          <mat-divider></mat-divider> -->
          @for (w of widgetsMenu ; track w) {
            <div>
              @if (w.active) {
                <button [disabled]="w.type=='productRegistration' && disableProductRegistration" mat-menu-item (click)="addWidget(w.type);">
                  @if (w.type=='annotatedMap') {
                    <mat-icon class="material-symbols-outlined">map</mat-icon>
                  }
                  @if (w.type=='annotation') {
                    <mat-icon class="material-symbols-outlined">home_pin</mat-icon>
                  }
                  @if (w.type=='annotationGroup') {
                    <mat-icon class="material-symbols-outlined">add_location_alt</mat-icon>
                  }
                  @if (w.type=='billboardImage') {
                    <mat-icon class="material-symbols-outlined">photo_album</mat-icon>
                  }
                  @if (w.type=='billboardVideo') {
                    <mat-icon class="material-symbols-outlined">subscriptions</mat-icon>
                  }
                  @if (w.type=='buttons') {
                    <mat-icon class="material-symbols-outlined">toast</mat-icon>
                  }
                  @if (w.type=='callToAction') {
                    <mat-icon class="material-symbols-outlined">badge</mat-icon>
                  }
                  @if (w.type=='form') {
                    <mat-icon class="material-symbols-outlined">article</mat-icon>
                  }
                  @if (w.type=='image') {
                    <mat-icon class="material-symbols-outlined">imagesmode</mat-icon>
                  }
                  @if (w.type=='images' || w.type=='imagesHorizontal' || w.type=='imageBlocks') {
                    <mat-icon class="material-symbols-outlined">burst_mode</mat-icon>
                  }
                  @if (w.type=='list') {
                    <mat-icon class="material-symbols-outlined">list</mat-icon>
                  }
                  @if (w.type=='text') {
                    <mat-icon class="material-symbols-outlined">article</mat-icon>
                  }
                  @if (w.type=='products') {
                    <mat-icon class="material-symbols-outlined">shopping_cart</mat-icon>
                  }
                  @if (w.type=='splashVideo') {
                    <mat-icon class="material-symbols-outlined">video_file</mat-icon>
                  }
                  @if (w.type=='shopify') {
                    <mat-icon class="material-symbols-outlined">shopping_bag</mat-icon>
                  }
                  @if (w.type=='spacer') {
                    <mat-icon class="material-symbols-outlined">space_bar</mat-icon>
                  }
                  @if (w.type=='video') {
                    <mat-icon class="material-symbols-outlined">slideshow</mat-icon>
                  }
                  @if (w.type=='3dmodel') {
                    <mat-icon class="material-symbols-outlined">view_in_ar</mat-icon>
                  }
                  @if (w.type=='notification') {
                    <mat-icon class="material-symbols-outlined">mark_chat_unread</mat-icon>
                  }
                  @if (w.type=='productRegistration') {
                    <mat-icon class="material-symbols-outlined">box_edit</mat-icon>
                  }
                  @if (w.type=='countdown') {
                    <mat-icon class="material-symbols-outlined">av_timer</mat-icon>
                  }
                  @if (w.type=='composed') {
                    <mat-icon class="material-symbols-outlined">extension</mat-icon>
                  }
                  @if (w.type=='chat') {
                    <mat-icon class="material-symbols-outlined">chat</mat-icon>
                  }
                  @if (w.type=='smartAR') {
                    <mat-icon class="material-symbols-outlined">eyeglasses</mat-icon>
                  }
                  @if (w.type=='instagram') {
                    <mat-icon class="material-symbols-outlined">post</mat-icon>
                  }
                  @if (w.type=='group') {
                    <mat-icon class="material-symbols-outlined">ad_group</mat-icon>
                  }
                  @if (w.type=='html') {
                    <mat-icon class="material-symbols-outlined">html</mat-icon>
                  }
                  @if (w.type=='oneClickPay') {
                    <mat-icon class="material-symbols-outlined">payments</mat-icon>
                  }
                  {{w.translate | translate}}
                  @if (w.betaWidget) {
                    <span class="badge custom-badge rounded-pill ms-1">Beta</span>
                  }
                  <!-- <span *ngIf="w.type=='form'|| w.type=='composed' || w.type=='productRegistration' || w.type=='chat' || w.type=='oneClickPay'" class="badge custom-badge rounded-pill ms-1">Beta</span> -->
                </button>
              }
              @if (!w.active) {
                <button mat-menu-item disabled><mat-icon>delete</mat-icon> {{w.translate | translate}}</button>
              }
            </div>
          }
        </mat-menu>
      <!-- widget list -->
      @if (allWidgets.length!=0) {
        <div cdkDropList class="example-list-edit mb-5" (cdkDropListDropped)="drop($event)">
          @for (el of allWidgets; track el; let i = $index) {
            <div class="example-box-edit" cdkDrag [class.selected]="selectedWidgetId === el.id" [attr.id]="'widget-item-' + i">
              <div class="d-inline-flex " style="width: 90%;" (click)="clickList(el,i, $event); $event.stopPropagation()">
                <div class="list-icon">
                  <span class="material-symbols-outlined">
                    @if (el.type=='annotatedMap'){map}
                    @if (el.type=='annotation'){home_pin}
                    @if (el.type=='annotationGroup'){add_location_alt}
                    @if (el.type=='billboardImage'){photo_album}
                    @if (el.type=='billboardVideo'){subscriptions}
                    @if (el.type=='buttons'){toast}
                    @if (el.type=='callToAction'){badge}
                    @if (el.type=='form'){article}
                    @if (el.type=='image'){imagesmode}
                    @if (el.type=='images' || el.type=='imagesHorizontal' || el.type=='imageBlocks'){burst_mode}
                    @if (el.type=='list'){list}
                    @if (el.type=='text'){article}
                    @if (el.type=='products'){shopping_cart}
                    @if (el.type=='productRegistration'){box_edit}
                    @if (el.type=='splashVideo'){video_file}
                    @if (el.type=='shopify'){shopping_bag}
                    @if (el.type=='spacer'){space_bar}
                    @if (el.type=='video'){slideshow}
                    @if (el.type=='3dmodel'){view_in_ar}
                    @if (el.type=='notification'){mark_chat_unread}
                    @if (el.type=='countdown'){av_timer}
                    @if (el.type=='composed'){extension}
                    @if (el.type=='chat'){chat}
                    @if (el.type=='smartAR'){eyeglasses}
                    @if (el.type=='group'){ad_group}
                    @if (el.type=='html'){html}
                    @if (el.type=='instagram'){post}
                    @if (el.type=='oneClickPay'){payments}
                  </span>
                </div>
                <div class="d-flex flex-column align-items-start" style=" width:80%;">
                  @if (!el.name) {
                    <span style="font-size: 1.1em;">{{widgetsNames[el.type]}} {{checkTypeNumber(el,i)}}</span>
                  }
                  @if (el.name) {
                    <span style="font-size: 1.1em;">{{el.name}} </span>
                  }
                  <span  style="font-size: 0.8em;" translate>pass.widgets.types.{{el.type}}</span>
                  @if (el.type=='annotatedMap') {
                    <span  style="font-size: 0.8em;" >{{el.annotations.length}} {{'pass.annotations'| translate}}</span>
                  }
                </div>
              </div>
              <div class="d-flex flex-row align-items-end">
                @if (el.type!='productRegistration') {
                  <button mat-icon-button matTooltip="{{'pass.widgets.copyWidgetToClipboard' | translate}}" class="copyall-icon" (click)="copyWidgetToClipboard(el);" >
                    <span class="material-symbols-outlined">copy_all</span>
                  </button>
                }
                @if (el.type!='productRegistration') {
                  <button mat-icon-button matTooltip="{{'pass.duplicateWidget' | translate}}" class="duplicate-icon" (click)="duplicateWidget(el, i);" [style.display]="el.type!='productRegistration' ? 'visible': 'none'" [disabled]="el.type!='productRegistration' ? false : true">
                    <span class="material-symbols-outlined">content_copy</span>
                  </button>
                }
                <button  mat-icon-button matTooltip="{{'pass.deleteWidget' | translate}}" class="delete-icon" color="warn" (click)="deleteWidget(el, i);">
                  <span class="material-symbols-outlined">delete</span>
                </button>
              </div>
              <!-- if widgtes empty -->
              @if (allWidgets.length==0) {
                <div class="example-list-edit"><p>{{'empty' | translate}}</p></div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
<div class="bottom-action-bar">
  <button mat-button class="cancel-editing bottom-cancel-button" (click)="backTo();">
    <mat-icon>arrow_back</mat-icon>
    {{'cancel' | translate}}
  </button>
  <div class="bottom-action-buttons">
    <button mat-button class="draft-save-button" (click)="saveDraft();" [disabled]="!changesToSave">
      {{ (hasDraft ? 'pass.saveDraft' : 'pass.saveAsDraft') | translate }}
    </button>
    <button mat-button class="orange-button publish-button" (click)="prepareToSave();" [disabled]="(!changesToSave && !hasDraft) || checkLicenseFree">
      {{'publishDesign' | translate }}
    </button>
  </div>
</div>
</div>
}

@if (translationMode) {
<div>
  <div [app-pass-templates-translations]="[templateForm.value,oldTemplateData, contextLanguages, languagesPassList ?? contextLanguages, contentTypeId, idToShow, passFirstLanguage ?? contextFirstLanguage, widgetAnchorOptions, childPageLinkOptions, activeTabId]" (returnChangesTranslations)=returnChangesActiveTranslations($event)></div>
</div>
}
